import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import PageCard from './components/PageCard';
import { formatCurrencyView } from './utils/currencyUtils';

function MovimentoAnual() {
  const [dadosAnual, setDadosAnual] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [anoSelecionado, setAnoSelecionado] = useState(
    localStorage.getItem('anoBase') || new Date().getFullYear().toString()
  );

  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');

  const meses = [
    { num: 1, nome: 'Janeiro', campo: 'janeiro', abrev: 'Jan' },
    { num: 2, nome: 'Fevereiro', campo: 'fevereiro', abrev: 'Fev' },
    { num: 3, nome: 'Março', campo: 'marco', abrev: 'Mar' },
    { num: 4, nome: 'Abril', campo: 'abril', abrev: 'Abr' },
    { num: 5, nome: 'Maio', campo: 'maio', abrev: 'Mai' },
    { num: 6, nome: 'Junho', campo: 'junho', abrev: 'Jun' },
    { num: 7, nome: 'Julho', campo: 'julho', abrev: 'Jul' },
    { num: 8, nome: 'Agosto', campo: 'agosto', abrev: 'Ago' },
    { num: 9, nome: 'Setembro', campo: 'setembro', abrev: 'Set' },
    { num: 10, nome: 'Outubro', campo: 'outubro', abrev: 'Out' },
    { num: 11, nome: 'Novembro', campo: 'novembro', abrev: 'Nov' },
    { num: 12, nome: 'Dezembro', campo: 'dezembro', abrev: 'Dez' },
  ];

  useEffect(() => {
    carregarDados();
  }, [anoSelecionado, token, cnpj]);

  const carregarDados = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL.MOVIMENTO}/anual`, {
        params: { cnpjAssociacao: cnpj, ano: anoSelecionado },
        headers: { Authorization: `Bearer ${token}` },
      });
      setDadosAnual(res.data);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      setDadosAnual(null);
    } finally {
      setLoading(false);
    }
  };



  return (
    <PageCard
      title="Movimento Anual"
      icon="bi-calendar-range"
      scrollable={true}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Resumo Anual */}
        {!isLoading && (
          <>
            <h6 className="mb-3 text-secondary">
              Resumo Geral - {anoSelecionado}
            </h6>
            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <div className="card border-success">
                  <div className="card-body text-center">
                    <i className="bi bi-piggy-bank text-success fs-1"></i>
                    <h6 className="text-muted mt-2 mb-1">Rendimentos</h6>
                    <h4 className="text-success mb-0">
                      {formatCurrencyView(dadosAnual?.totalRendimentos ?? 0)}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card border-info">
                  <div className="card-body text-center">
                    <i className="bi bi-graph-up text-info fs-1"></i>
                    <h6 className="text-muted mt-2 mb-1">Receitas</h6>
                    <h4 className="text-info mb-0">
                      {formatCurrencyView(dadosAnual?.totalReceitas ?? 0)}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="card border-danger">
                  <div className="card-body text-center">
                    <i className="bi bi-graph-down text-danger fs-1"></i>
                    <h6 className="text-muted mt-2 mb-1">Despesas</h6>
                    <h4 className="text-danger mb-0">
                      {formatCurrencyView(dadosAnual?.totalDespesas ?? 0)}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className={`card border-${(dadosAnual?.totalSaldo ?? 0) >= 0 ? 'primary' : 'warning'}`}>
                  <div className="card-body text-center">
                    <i className={`bi bi-calculator text-${(dadosAnual?.totalSaldo ?? 0) >= 0 ? 'primary' : 'warning'} fs-1`}></i>
                    <h6 className="text-muted mt-2 mb-1">Saldo do Período</h6>
                    <h4 className={`text-${(dadosAnual?.totalSaldo ?? 0) >= 0 ? 'primary' : 'warning'} mb-0`}>
                      {formatCurrencyView(dadosAnual?.totalSaldo ?? 0)}
                    </h4>
                  </div>
                </div>
              </div>
            </div>

            {/* Tabela Mensal */}
            <h6 className="mb-3 text-secondary">
              Movimento Mês a Mês
            </h6>
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Mês</th>
                    <th className="text-end">Rendimentos</th>
                    <th className="text-end">Receitas</th>
                    <th className="text-end">Despesas</th>
                    <th className="text-end bg-light fw-bold">Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  {(dadosAnual?.meses || []).map((mesData, idx) => (
                    <tr key={idx}>
                      <td className="fw-bold">{mesData.mes}</td>
                      <td className="text-end text-success">
                        {formatCurrencyView(mesData.rendimentos ?? 0)}
                      </td>
                      <td className="text-end text-info">
                        {formatCurrencyView(mesData.receitas ?? 0)}
                      </td>
                      <td className="text-end text-danger">
                        {formatCurrencyView(mesData.despesas ?? 0)}
                      </td>
                      <td className={`text-end fw-bold ${(mesData.saldo ?? 0) >= 0 ? 'text-primary' : 'text-warning'}`}>
                        {formatCurrencyView(mesData.saldo ?? 0)}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot className="table-secondary fw-bold">
                  <tr>
                    <td>TOTAL ANUAL</td>
                    <td className="text-end text-success">
                      {formatCurrencyView(dadosAnual?.totalRendimentos ?? 0)}
                    </td>
                    <td className="text-end text-info">
                      {formatCurrencyView(dadosAnual?.totalReceitas ?? 0)}
                    </td>
                    <td className="text-end text-danger">
                      {formatCurrencyView(dadosAnual?.totalDespesas ?? 0)}
                    </td>
                    <td className={`text-end ${(dadosAnual?.totalSaldo ?? 0) >= 0 ? 'text-primary' : 'text-warning'}`}>
                      {formatCurrencyView(dadosAnual?.totalSaldo ?? 0)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {/* Gráfico Visual Simplificado */}
            <h6 className="mb-3 mt-4 text-secondary">
              Evolução Mensal
            </h6>
            <div className="card">
              <div className="card-body">
                <div className="row">
                  {(dadosAnual?.meses || []).map((mesData, idx) => {
                    const totalEntradas = (mesData.rendimentos ?? 0) + (mesData.receitas ?? 0);
                    const despesasMes = mesData.despesas ?? 0;
                    const maxValor = Math.max(totalEntradas, despesasMes);
                    const alturaEntradas = maxValor > 0 ? (totalEntradas / maxValor) * 100 : 0;
                    const alturaDespesas = maxValor > 0 ? (despesasMes / maxValor) * 100 : 0;
                    
                    return (
                      <div key={idx} className="col-1 text-center">
                        <div style={{ height: '150px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                          <div
                            className="bg-success mb-1"
                            style={{ height: `${alturaEntradas}%`, minHeight: totalEntradas > 0 ? '5px' : '0' }}
                            title={`Entradas: ${formatCurrencyView(totalEntradas)}`}
                          ></div>
                          <div
                            className="bg-danger"
                            style={{ height: `${alturaDespesas}%`, minHeight: despesasMes > 0 ? '5px' : '0' }}
                            title={`Despesas: ${formatCurrencyView(despesasMes)}`}
                          ></div>
                        </div>
                        <small className="text-muted fw-bold">{meses[idx]?.abrev}</small>
                      </div>
                    );
                  })}
                </div>
                <div className="mt-3 d-flex justify-content-center gap-4">
                  <div>
                    <span className="badge bg-success me-2">■</span>
                    <small>Entradas (Rendimentos + Receitas)</small>
                  </div>
                  <div>
                    <span className="badge bg-danger me-2">■</span>
                    <small>Despesas</small>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {isLoading && (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
            <p className="mt-3 text-muted">Carregando dados...</p>
          </div>
        )}
      </div>
    </PageCard>
  );
}

export default MovimentoAnual;
